<template>
	<ion-select
		v-if="props.visible"
		v-model="selectedLanguage"
		:aria-label="$t('menu.language')"
		:placeholder="$t('menu.language')"
		class="ion-text-uppercase"
		@ion-change="handleChange()"
	>
		<div slot="label">
			<ion-row class="ion-align-items-center ion-text-capitalize">
				<ion-icon :icon="earth" aria-hidden="true"></ion-icon>
				<ion-label class="ml-1">
					{{ t("menu.language") }}
				</ion-label>
			</ion-row>
		</div>

		<ion-select-option
			v-for="language of availableLocales"
			:key="`lang-${language}`"
			:value="language"
			class="ion-text-uppercase"
			>{{ language }}</ion-select-option
		>
	</ion-select>
</template>
<script setup lang="ts">
	import {
		IonSelect,
		IonSelectOption,
		IonIcon,
		IonLabel,
		IonRow,
	} from "@ionic/vue";
	import { earth } from "ionicons/icons";
	import { ref, onMounted, watch } from "vue";
	import { useI18n } from "vue-i18n";
	import { useSetUserLocale } from "seedgreen-shared/queries/user";

	const props = defineProps<{
		visible: boolean;
		userLocale?: string;
	}>();

	const { setUserLocale } = useSetUserLocale();

	const selectedLanguage = ref("");

	const { locale, t, availableLocales } = useI18n();

	const setLocale = (newLocale: string) => {
		if (availableLocales.includes(newLocale)) {
			selectedLanguage.value = newLocale;
		} else {
			selectedLanguage.value = locale.value; // Default language
		}
	};

	onMounted(() => {
		// 1 check user locale
		// 2 check browser locale
		// 3 check default locale
		// 4 set locale
		let userLanguage = null; // Default locale
		if (props.userLocale) {
			userLanguage = props.userLocale;
		} else {
			userLanguage = navigator.language;
		}
		userLanguage = userLanguage.split("-")[0]; // Get the language code (e.g., "en" from "en-US")
		setLocale(userLanguage);
	});
	watch(props, (newValue) => {
		if (newValue) {
			setLocale(newValue.userLocale || "");
		}
	});

	const handleChange = async () => {
		locale.value = selectedLanguage.value;

		if (!props.userLocale) return;
		try {
			await setUserLocale(selectedLanguage.value);
		} catch (error) {
			console.error(error);
		}
	};
</script>

<style scoped>
	ion-select {
		width: fit-content;
	}
</style>
